import React, { memo } from 'react';
import { makeStyles } from '@mui/styles';
import { useSelector } from 'react-redux';

import useConditionalSubmit from '../../../../../hooks/useConditionalSubmit';
import StyledSubmitButton from '../../../../../components/Shared/StyledSubmitButton';
import { getGiftGl, getIsDonationProduct } from '../../../store/data/data.selectors';
import { IAlyceCustomTheme } from '../../../../../styles/alyceTheme';
import { getIsPreview } from '../../../store/statuses/statuses.selectors';
import { IProduct } from '../../../types/Product.types';

const useStyles = makeStyles<IAlyceCustomTheme>(({ palette }) => ({
  buttonText: {
    lineHeight: '1.15 !important',
    color: `${palette.customStyling.primaryCtaColor} !important`,
  },
}));

export interface IAcceptButtonProps {
  onSubmit: (product: IProduct, confirmedFlowStepId: string | null) => void;
}

const AcceptButton = ({ onSubmit }: IAcceptButtonProps): JSX.Element => {
  const classes = useStyles();
  const gl = useSelector(getGiftGl);
  const isDonation = useSelector(getIsDonationProduct);
  const isPreview = useSelector(getIsPreview);

  const buttonText = isDonation ? 'Make this donation' : `Accept your ${gl}`;
  const handleSubmit = useConditionalSubmit(!isPreview, onSubmit);

  return (
    <StyledSubmitButton data-testid="giftAcceptButton" width="100%" onClick={handleSubmit} variant="outlined">
      <span className={classes.buttonText}>{buttonText}</span>
    </StyledSubmitButton>
  );
};

export default memo<IAcceptButtonProps>(AcceptButton);
